<template>
  <div class="main-view">
    <h1 class="text-center">Main View</h1>
    <nav class="d-flex justify-content-center mb-4">
      <router-link to="/hello" class="me-2">
        <button class="btn btn-outline-primary">Hello World</button>
      </router-link>
      <router-link to="/companies" class="me-2">
        <button class="btn btn-outline-secondary">Companies List</button>
      </router-link>
      <button @click="toggleHeader" class="btn btn-outline-info">Toggle MainHeader</button>
      <button @click="toggleChatbot" class="btn btn-outline-info">Toggle Chatbot</button>
      <button @click="toggleFooter" class="btn btn-outline-info">Toggle Footer</button>
    </nav>

    <div class="container mt-4">
      <vue-select
        v-model="componentName"
        :options="componentNames"
        label="Komponentenname auswählen oder eingeben"
        class="form-control mb-2"
        placeholder="Komponentenname auswählen oder eingeben"
      ></vue-select>
      <button @click="openComponentView" class="btn btn-outline-success">Open Component As View</button>
    </div>

    <!-- Anzeige des Headers, wenn showHeader true ist -->
    <MainHeader v-if="showHeader" />

    <div class="d-flex justify-content-center">
      <Chatbot v-if="showChatbot" />
    </div>

    <!-- Anzeige des Footers, wenn showFooter true ist -->
    <Footer v-if="showFooter" />
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import Footer from '@/components/Footer.vue';
import Chatbot from '@/components/Chatbot.vue';
import VueSelect from 'vue3-select';

export default {
  name: 'MainView',
  components: {
    MainHeader,
    Footer,
    Chatbot,
    VueSelect,
  },
  data() {
    return {
      showHeader: false,
      showFooter: false,
      showChatbot: false,
      showContentBlock: false,
      componentName: '',
      componentNames: [
        // Fügen Sie hier alle registrierten Komponenten aus DynamicComponentView hinzu
        'MainView',
        'HelloWorldView',
        'CompanyListView',
        'MainHeader',
        'Footer',
        'Chatbot',
        'CompanyList',
        'HelloWorld',
        'ToolDescriptionContent',
        'ToolDescriptionPageView',
        'Stepper',
        'StepperHeading',
        'SolutionDetails',
        'HomeContent',
        'HomeView',
        'StepperView',
        'Playground',
        'LogInMask',
        'LogInMaskView',
        'RegisterMask',
        'RegisterMaskView',
      ],
      
    };
  },
  methods: {
    toggleHeader() {
      this.showHeader = !this.showHeader;
    },
    toggleFooter() {
      this.showFooter = !this.showFooter;
    },
    toggleChatbot() {
      this.showChatbot = !this.showChatbot;
    },
    toggleContentBlock() {
      this.showContentBlock = !this.showContentBlock;
    },
    openComponentView() {
      if (this.componentName) {
        // Die Route wechseln, ohne den Wert im Textfeld zu ändern
        this.$router.push({ name: 'dynamic-component', params: { componentName: this.componentName } });
      } else {
        alert('Bitte geben Sie einen Komponenten-Namen ein.');
      }
    },
  },
};
</script>

<style scoped>
nav {
  margin-bottom: 20px;
}

button {
  margin-right: 10px;
  padding: 10px 20px;
  font-size: 16px;
}

.container input {
  max-width: 300px;
  margin: 0 auto;
}
</style>
